/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useMemo } from 'react';
import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FaMapMarkerAlt } from "react-icons/fa";

import { formatHHMM } from '../../../../utils';
import { theme } from '../../../../theme';
import HeaderTexts from '../../common/HeaderTexts';
import { updateStoredJobDetails } from '../../service';

const MIN_DISTANCE = 2;
const styles = {
    boldText: { fontWeight: "bold" },
    smallText: { fontWeight: "bold", fontSize: "10px" },
};

const Range = ({range, setRange, calculateFutureTime, isHome = false, isSliderDisabled = false}) => {

    const handleChange = useCallback((event, newValue, activeThumb) => {
        if (!Array.isArray(newValue)) return;

        setRange(([min, max]) => {
            const updatedRange =
                activeThumb === 0
                    ? [Math.min(newValue[0], max - MIN_DISTANCE), max]
                    : [min, Math.max(newValue[1], min + MIN_DISTANCE)];

            updateStoredJobDetails("range", updatedRange);

            return updatedRange;
        });
    }, []);

    const handleValueLabelFormat = useCallback(
        (value) => formatHHMM(calculateFutureTime(value)),
        [calculateFutureTime]
    );

    const formattedStart = useMemo(
        () => formatHHMM(calculateFutureTime(range[0])),
        [calculateFutureTime, range]
    );

    const formattedEnd = useMemo(
        () => formatHHMM(calculateFutureTime(range[1])),
        [calculateFutureTime, range]
    );

    return(
        <div className="mt-1 mx-3">
            <HeaderTexts
                title="Select your arrival window" 
                subTitle=""
            />
            
            <Box>
                {isHome && (
                    <Container>
                        <Row>
                            <Col className="text-start ps-0" style={styles.boldText}>
                                {formattedStart}
                            </Col>
                            <Col className="text-end pe-0" style={styles.boldText}>
                                {formattedEnd}
                            </Col>
                        </Row>
                    </Container>
                )}
                <Slider
                    sx={{ color: theme.main_code, mt: 4 }}
                    value={range}
                    onChange={handleChange}
                    valueLabelFormat={handleValueLabelFormat}
                    onChangeCommitted={(event, newValue) => console.log(newValue)}
                    valueLabelDisplay="auto"
                    disableSwap
                    min={1}
                    max={9}
                    disabled={isSliderDisabled}
                />
                <Container>
                    <Row>
                        <Col className="text-start ps-0" style={styles.smallText}>
                            <FaMapMarkerAlt /> ARRIVE AFTER
                        </Col>
                        <Col className="text-end pe-0" style={styles.smallText}>
                            ARRIVE BEFORE <FaMapMarkerAlt />
                        </Col>
                    </Row>
                </Container>
            </Box>
        </div>
    );
};

export default Range;